<template>
  <div class="grid h-screen md:grid-cols-[auto_1fr]">
    <Sidebar />

    <main class="no-scrollbar flex grow overflow-y-auto">
      <slot />
    </main>
  </div>
</template>
